.uic-filter {
    display: inline-block;

    &__wrapper {
        background: var(--uic-list-background, white);
        box-shadow: var(--uic-list-box-shadow);
    }

    &__list {
        box-sizing: border-box;
        border: var(--uic-list-border);
        border-bottom: 0;
        min-height: 64px;
        position: relative;
    }

    &__scroller {
        max-width: var(--uic-list-popover-max-width);
        max-height: var(--uic-list-popover-max-height);
        height: var(--uic-list-popover-max-height);
    }

    &__item {
        padding-left: 12px;
    }

    &__search {
        width: 100%;
        border: var(--uic-list-border);
        border-bottom: 0;
        padding: 12px;
    }

    &__value {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: var(--uic-line-height-normal);
        font-size: var(--uic-font-size-normal);
        font-weight: var(--uic-font-weight-semibold);
        color: var(--uic-color-black);
    }

    &__icon {
        --uic-icon-width: var(--uic-icon-dimensions-default);
        --uic-icon-height: var(--uic-icon-dimensions-default);
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        right: 0;
        top: 0;
        width: 50px;
        height: 100%;
        color: var(--uic-color-black);
    }

    &__label {
        display: block;
        overflow: hidden;
        padding-bottom: 4px;
        color: var(--uic-color-black);
        font-size: var(--uic-font-size-normal);
        font-weight: var(--uic-font-size-normal);
        line-height: var(--uic-line-height-normal);
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    &__button {
        width: 100%;
        position: relative;
        padding-right: 45px;
        padding-left: 8px;
        text-align: left;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        border: 0;
        padding: 13px 45px 11px 8px;
        background: var(--uic-color-white);
        outline: 2px solid transparent;
        outline-offset: -2px;

        &:focus {
            outline-color: var(--uic-color-blue2);
        }

        &:active .uic-filter__value,
        &:active .uic-filter__icon,
        &:hover .uic-filter__value,
        &:hover .uic-filter__icon {
            color: var(--uic-color-blue3);
        }

        &:disabled .uic-filter__value,
        &:disabled .uic-filter__icon {
            color: var(--uic-color-grey5);
        }
    }

    &__no-search-results {
        @include font(normal);
        box-sizing: border-box;
        display: none;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        color: var(--uic-color-grey3a75);
        min-height: 64px;
        padding: 12px;
    }

    &__no-search-results-default {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 8px;
    }

    &--no-results &__no-search-results {
        display: block;
    }

    &--open {
        .uic-filter__icon {
            transform: rotate(180deg);
        }
    }

    &__item--nested {
        padding-left: 28px;
    }

    &__item--separated::after {
        content: "";
        position: absolute;
        background: var(--uic-color-grey2);
        height: 1px;
        left: 0;
        bottom: 0;
        right: 0;
    }
}
